import React from 'react';
import styles from './ratingTrend.module.scss';

const RatingTrend = (props) => {
    const { rating, ratingDifference, changeDirection, showDifferenceValue } = props;
    const valueToDisplay = showDifferenceValue ? Math.abs(ratingDifference).toFixed(2) : rating.toFixed(2);

    if (changeDirection?.toLowerCase() === 'up') {
        return (
            <span className={styles.ratingTrend}>
                <span>{valueToDisplay}</span>
                <div className="utr-icon icon-arrow-up-blue" title="up" />
            </span>
        );
    } if (changeDirection?.toLowerCase() === 'down') {
        return (
            <span className={styles.ratingTrend}>
                <span>{valueToDisplay}</span>
                <div className="utr-icon icon-arrow-down-blue" title="down" />
            </span>
        );
    }
    if (changeDirection?.toLowerCase() === 'none') {
        return (
            <span className={styles.ratingTrend}>
                <span>{valueToDisplay}</span>
                <div className="utr-icon icon-arrow-neutral-blue" title="" />
            </span>
        );
    }
    return (
        <span className={styles.ratingTrend}>--</span>
    );
};

export default RatingTrend;
